export default __webpack_public_path__ + "static/hex-light-simple-e5caea24eec9a871f9cf38919a7338ab.svg";